module.exports = __webpack_public_path__ + "static/veri-odak-3cb1f1942516ba24b9b0b493b25ddb83.png";